export default {
  // 단어
  'profile': 'プロフィール',
  'user': 'ユーザー',
  'login': 'ログイン',
  'logout': 'ログアウト',
  'ID': 'ID',
  'ID_email': 'ID (メール形式)',
  'PW': 'パスワード',
  'PW_desc': '英文字、特殊文字、数字を混合して8～12文字で入力してください',
  'PW_confirm': 'パスワード確認',
  'PW_confirm_desc': '同じパスワードを入力してください',
  'agreement_view_text': '閲覧',
  'required_label': '必須',
  'PW_origin':'現在のパスワード',
  'PW_new':'新しいパスワード',
  'PW_new_confirm':'新しいパスワード確認',
  'check_email_message':'メールをご確認ください',
  'check_email_desc':'登録したメールアドレスで認証ボタンをクリックしてください',
  'footer':'Copyright 2025. KOINO Inc. All rights reserved.',
  'SC0010': 'クレジットカード',
  'SC0030': '口座振替',
  'SC0060': '携帯決済',
  'Superadmin': 'サービス',
  'Corporate': 'コーポレート',
  'LMM100': 'LMM100',
  'LMM300': 'LMM300',
  'LMM500': 'LMM500',
  'LMM1000': 'LMM1000+',
  'LMM1000+': 'LMM1000+',
  'Basic': 'ベーシック',
  'Free': '無料体験',
  'Email': 'メール',
  'name': '名前',
  'phone': '電話番号',
  'office_phone': 'オフィス電話',
  'subscription_path': '加入経路',
  'windows': 'ウィンドウズ',
  'Windows': 'ウィンドウズ',
  'linux': 'リナックス',
  'mac': 'マック',
  'android': 'アンドロイド',
  'agent': 'エージェント',
  'remote_device': 'リモートデバイス',
  'download': 'ダウンロード',
  'manual': 'マニュアル',
  'service': 'サービス',
  'payment': '決済',
  'manage': '管理',
  'manager': '管理者',
  'group': 'グループ',
  'group_info': 'グループ情報',
  'multiple': '多重',
  'information': '情報',
  'threshold': '警告基準',
  'limit': '閾値',
  'alert': '警告',
  'normal': '正常',
  'setting': '設定',
  'device': 'リモートデバイス',
  'type': 'タイプ',
  'add': '追加',
  'add_n': '{v} 追加',
  'remove': '削除',
  'delete': '削除',
  'progress': '進行',
  'time': '時間',
  'hour': '時',
  'minute': '分',
  'second': '秒',
  'device-in-group': 'グループ内のリモートデバイス',
  'list-of': '{v} リスト',
  'total': '全体',
  'history': '履歴',
  'registration': '申請',
  'statistics': '統計',
  'stats': '統計',
  'update': '延長',
  'renew': '更新',
  'connected': '接続済み',
  'disconnected': '切断済み',
  'running': '稼働中',
  'sub-manager': 'サブユーザー',
  'execute': '実行',
  'cancel': 'キャンセル',
  'ea': '個',
  'WON': 'ウォン',
  'months': 'ヶ月',
  'years': '年',
  'back': '戻る',
  'expire': '期限切れ',
  'notify': '通知',
  'help': 'ヘルプ',
  'status': '状態',
  'program': 'プログラム',
  'homepage': 'ホームページ',
  'web': 'ウェブ',
  'proposal': '提案書',
  'brochure': 'パンフレット',
  'ios': 'iOS',
  'etc': 'その他',
  'on-work': '準備中',
  'list-view': 'リスト',
  'card-view': 'アイコン',
  'live-view': 'サムネイル',
  'delete-n': '{v} 削除',
  'move-group-n': 'グループ移動',
  'selected': '選択済み',
  'accessable': 'アクセス可能',
  'empty': 'なし',
  'device_limit': 'リモートデバイスの最大登録数制限',
  'device_name': 'リモートデバイス名',
  'device_name_identical': '同じリモートデバイス名です。',
  'device_name_edit': 'リモートデバイス名変更',
  'device_name_desc': 'リモートデバイス名を <b>{alias}</b> から以下のように変更します。<br><br>[変更リモートデバイス名を入力]',
  'device_name_confirm': 'リモートデバイス名が <b>{alias}</b> から<br><b>{value}</b> に変更されます。',
  // MDM 機器ポリシー(構成)適用
  'mdm_config': '構成',
  'mdm_config_unassigned': '未割当',
  'mdm_apply_config': 'リモートデバイス構成変更',
  'device_location_map': 'リモートデバイス位置を表示',
  'map_search_placeholder': 'デバイス検索',
  'map_select_all': 'すべて選択',
  'map_shown_count': '{count}台表示',
  'map_empty': '位置が報告されたオンラインデバイスがありません。',
  'mdm_change_config': '構成変更',
  'mdm_apply_config_desc': '選択したリモートデバイスに適用する構成を選択してください。構成のOSと一致する機器にのみ適用されます。',
  'mdm_apply_config_placeholder': '構成選択',
  'mdm_apply_summary': '適用 {apply}台 · 除外 {skip}台',
  'mdm_apply_skip_reason': '既に同一 {same} · OS不一致 {os}',
  'mdm_apply_target': '対象デバイス',
  'mdm_apply_target_count': '{count}台',
  'mdm_config_current_applied': '(現在適用中)',
  'mdm_os_unsupported': '未対応',
  'mdm_apply_none': '選択した構成を適用できる機器がありません。',
  'mdm_apply_done': '構成適用完了 ({success}台)',
  'mdm_apply_done_excluded': '構成適用完了 (適用 {success}台 · 除外 {excluded}台)',
  'mdm_status_applied': '適用済み',
  'mdm_status_pending': '待機',
  'mdm_status_failed': '失敗',
  'O/S': 'O/S',
  'edit': '編集',
  'refresh': '更新',
  'off-editmode': '編集モード終了',
  'emptied_memo': '-',
  'upper_group': '上位グループ',
  'all_device': 'すべてのリモートデバイス',
  'submit': '確認',
  'create': '作成',
  'delete_group': 'グループ削除',
  'delete_device': 'リモートデバイス削除',
  'device_logoff': 'リモートデバイスログオフ',
  'favorate': 'お気に入り',
  'search': '検索',
  'by_user': 'ユーザー別 {v}',
  'by_device': 'リモートデバイス別 {v}',
  'by_type': 'タイプ別 {v}',
  'by_daily': '日別',
  'by_monthly': '月別',
  'alert_count': '警告発生回数',
  'use_rate': '使用率',
  'rate': '比率',
  'use_count': '回数',
  'select_date': '期間選択',
  'connect_count_of_remote': 'リモート制御試行回数の推移',
  'count_of_alert': '警告発生回数の推移',
  'chart': 'チャート',
  'date': '日付',
  'host': 'ホスト',
  'viewer': 'ビューア',
  'at_time': '日時',
  'start_time': '開始時間',
  'end_time': '終了時間',
  'start_date': '開始日',
  'expire_date': '期限日',
  'event_time': '発生時間',
  'login_time': '接続時間',
  'delete_time': '削除時間',
  'payment_date': '決済日',
  'type_of_device': 'リモートデバイスタイプ',
  'alert_message': '警告メッセージ',
  'browser': 'ブラウザ',
  'file_name': 'ファイル名',
  'size': 'サイズ',
  'top10': 'トップ10',
  'change': '変更',
  'do_change': '変更する',
  'advenced_auth': '2段階認証(OTP)',
  'department': '部署',
  'cowork_position': '役職',
  'timezone': '標準時間帯',
  'date_format': '@:date 形式',
  'time_sec': '時間(秒)',
  'auto_update': '自動更新',
  'active': '活性化',
  'inactive': '非活性化',
  'permission': '権限',
  'target': '対象',
  'common': '共通',
  'web_manager': 'ウェブマネージャ',
  'CS_manager': 'CSマネージャ',
  'empty_manager': '@:manager @:empty',
  'empty_phone': '@:phone @:empty',
  'empty_Email': '@:Email @:empty',
  'license': 'ライセンス',
  'regist_service': '@:license 追加',
  'update_service': '@:service 更新',
  'device_type': 'デバイスタイプ',
  'device_vol': 'リモートデバイス数',
  'exceed_device_vol': '超過リモートデバイス数',
  'remain': '残り期間',
  'period': '期間',
  'price': '価格',
  'total_price': '合計金額',
  'payment_type': 'デバイスタイプ',
  'payment_method': '決済手段',
  'remark': '備考',
  'notice': 'お知らせ',
  'cs_center': '顧客センター',
  'cs_phone': '02-6949-0488, 070-7126-8663',
  'save': '保存',
  'find_n': '{v} 検索',
  'check_n': '{v} 確認',
  'signup': '会員登録',
  'trial': '無料体験',
  'use_for': '加入区分',
  'personal': '個人',
  'enterprise': '企業',
  'company': '会社',
  'continue': '続行',
  'temperature': '温度',
  'speed': '速度',
  'running_time': 'ランニングタイム',
  'system_time': 'システム時間',
  'version': 'バージョン',
  'access_log': 'アクセス/制御履歴',
  'list_of_process': 'プロセス一覧',
  'list_of_hardware': 'ハードウェア一覧',
  'list_of_software': 'ソフトウェア一覧',
  'enter_n': '{v} 入力',
  'reset_n': '{v} リセット',
  'authorization': '本人認証',
  'send_n': '{v} 送信',
  'resend_n': '{v} 再送',
  'close': '閉じる',
  'secure': 'セキュリティ',
  'available_count': '利用可能デバイス',
  'submanager-right': '部署長権限',
  'access-registration-history': 'リモートデバイス制御アクセス申請履歴',
  'access-num': 'シリアル番号',
  'device-name': 'リモートデバイス名',
  'device-ip': 'リモートデバイスIP',
  'application-date': '受付時間',
  'application-period': '申請期間',
  'approver': '承認者',
  'applicant': '申請者',
  'approval-status': '承認状況',
  'approval': '承認',
  'approval-ing': '進行中',
  'function-settings': 'ポリシー管理',
  'function-settings01': 'ログイン失敗アカウントロック回数(回)',
  'function-settings02': 'リモートアクセスアイドル時間(分)',
  'function-settings03': 'ファイル転送',
  'blocking-settings': 'アクセスIP管理',
  'blocking-settings01': 'ブロック/許可ポリシー',
  'approval-submit-user': '再申請',
  'blocking-super-settings': 'ポリシー使用',
  'reset-pw': 'リセット',
  'reject-submit': '却下',
  'reject': '拒否',
  'security-access': '同意',
  'manager-id': '管理者',
  'sub-manager-id': '中間管理者',
  'reject-access': '承認キャンセル',
  'request-agent': 'リモートデバイス',
  'request-date': '申請期間',
  'request-reason': '理由',
  'approval-reason': '部署長意見',
  'security-access-title': 'セキュリティ誓約書同意',
  'excel-form': 'Excelフォームダウンロード',
  'approval-apply': '承認プロセス適用',
  'user-in-group': 'グループアクセス権限ユーザー',
  'deleted-device-edit': '編集',
  'request-history': 'アクセス申請履歴',
  'approval-process': 'アクセス申請承認',
  'approval-process-history': 'アクセス申請承認履歴',
  'major-os-version': 'メジャーOSバージョン',
  'minor-os-version': 'マイナーOSバージョン',
  'session-time': 'リモートアクセス維持時間(分)',
  'account_security': 'アカウントセキュリティ',
  'password_level': 'パスワード難易度設定',
  'password_level0': '制限なし (4～12文字)',
  'password_level1': '英文字 + 数字 (6～12文字)',
  'password_level2': '英文字 + 数字 + 特殊文字 (8～12文字)',
  'password_level3': '大文字英文字 + 小文字英文字 + 数字 + 特殊文字 (8～12文字)',
  'self_unlock': 'ロックアカウント自己解除許可',
  'vaccine': 'プロセス/サービス名検出',
  'capture': '画面キャプチャおよび録画',
  'display-power-save': '画面省電力防止',
  'system-power-save': 'システム省電力防止',
  'security-agreement': 'セキュリティ誓約書使用',
  'remote-policy': 'リモート機能ポリシー',
  'user-connection-policy': 'ユーザー接続環境ポリシー',
  'os-version': 'Windows OSバージョン許可',
  'blocking-settings-ip-list': 'アクセスIPリスト',
  'single-ip': '単一IPアドレス',
  'reason': '理由',
  'range-ip-start': '開始アドレス',
  'range-ip-end': '終了アドレス',
  'subnet-ip': 'サブネットアドレス',
  'time-added': '適用時間',
  'ip-address': 'IPアドレス',
  'password-expired': 'パスワード最大使用期間(日)',
  'excel-users': 'ユーザー一括登録',
  'enrollment': '登録',
  'excel-groups': 'グループ一括登録',
  'account-manage': 'ユーザー',
  'all-devices': 'リモートデバイス',
  'tutorial': 'チュートリアル',
  'device-drop-all': 'すべてのPC',
  'service-payment-history': 'サービス決済履歴',
  'tutorial-device': '初めて利用しますか？（リモートPC追加方法を見る）',
  'tutorial-group': 'グループ管理の案内が必要ですか？（グループ管理機能を見る）',
  'tutorial-manager': 'ユーザーアカウントとは何ですか？（アカウント管理機能を見る）',
  'tutorial-statistics': '統計/履歴で提供される機能とは？（統計/履歴機能を見る）',
  'tutorial-top10': 'グループ管理の案内が必要ですか？（グループ管理機能を見る）',
  'tutorial-download': 'リモートデバイスのダウンロードとインストールガイド',
  'tutorial-license': '電子決済ができませんか？',
  'first-add-device': 'リモートPCを追加',
  'download_remote_device': 'エージェント導入',
  
  // 메세지
  'no-selects': '選択された項目がありません。',
  'no-content': '該当する項目がありません。',
  'no-agent': '登録されたリモートデバイスがありません。リモートPCを追加してください。',
  'on_working': '準備中です。',
  'has_new_message': '新しい通知があります。',
  'not_save_warning': '保存されていない内容は反映されません。進行しますか？',
  'not_online_warning': 'リモートデバイスがオンライン状態ではありません。',
  'no_input_data': '入力された内容がありません。',
  'add_child_group': '「{name}」のサブグループを追加します。<br>グループ名を入力してください。',
  'add_root_group': '「最上位」にグループを追加します。<br>グループ名を入力してください。',
  'duplication_group_name': '同じ名前のグループが同じ位置にあります。',
  'created_group': 'グループが作成されました。',
  'please_select_group': 'グループを選択してください。',
  'identical_group': '同じリモートデバイスグループへの移動を試みました。別のリモートデバイスグループを選択してください。',
  'confirm_delete_group': 'グループを削除すると、そのグループ内のデバイスはデフォルトグループに移動されます。<br>削除しますか？',
  'deleted_group': 'グループが削除されました。',
  'all_device_has_no_child': 'すべてのリモートデバイスにサブグループを含めることはできません。',
  'confirm_delete_device': `
    登録されたリモートデバイスを削除します。<br>
    削除されたリモートデバイスを再接続するには、リモートでログインが必要です。<br>
    <br>
    <h6 class="delete-target">{name}</h6>
  `,
  'confirm_device_logoff': '登録されたリモートデバイスをログオフします。',
  'access-ticket': '制御権申請',
  'ticket-request': '制御権申請管理',
  'at.requested': '承認要求中',
  'at.re-requested': '再承認要求中',
  'at.approved': '承認完了',
  'at.on-work': '作業中',
  'at.reject': '却下',
  'at.completed': '終了',
  'at.Unknown': '不明な状態',
  'has_request_ticket': '{count}件の制御権申請があります。',
  'deleted_device': 'リモートデバイスが削除されました。',
  'moved_device': '「{device}」が「{group}」に移動されました。',
  'moved_device_by': '「{device}」が「{group}」に移動されました。',
  'moved_device_fail': '「{name}」は移動できません。',
  'deleted_device_count': '[{count}/{total}] リモートデバイスが削除されました。',
  'no_order_warning': 'グループ順序の移動はサポートされていません。昇順で並べ替えられます。',
  'delete_user_confirm': 'このユーザーを削除しますか？',
  'delete_group_confirm': 'このグループを削除しますか？',
  'delete_checked_user_confirm': '選択したユーザーを削除しますか？',
  'user_active_changed': '「{name}」が「{status}」に変更されました。',
  'deleted_user': 'ユーザーが削除されました。',
  'created_user': 'ユーザーが登録されました。',
  'updated_memo': 'メモが修正されました。',
  'update_agent_requested': '更新が要求されました。',
  'update_agent_desc': 'リモートデバイスのリモートプログラムを更新します。<br>現在のバージョン: {current_ver} > 最新バージョン: {latest_ver}',
  'delete_threshold': 'この警告基準を削除しますか？',
  'no_perm_group': 'このグループへの権限がありません。',
  'add_permission_of_group': `
    このグループの権限を付与するために以下の上位グループに対する権限が必要です。
    <br><br>
    [{groups}]
    <br><br>
    許可しますか？
  `,
  'delete_permission_of_group': `
    このグループの権限を削除するために以下の下位グループに対する権限削除が必要です。
    <br><br>
    [{groups}]
    <br><br>
    許可しますか？
  `,
  'please_select': '選択してください。',
  'please_input': '入力してください。',
  'please_select_device_type': 'リモートデバイスタイプを@:please_select',
  'please_select_alert_type': '警告タイプを@:please_select',
  'please_input_alert_time': '進行時間を@:please_input',
  'please_input_alert_value': '閾値を@:please_input',
  'please_input_memo': 'メモを@:please_input',
  'permissions': {
    'deviceMonitor': 'リモートデバイスモニタリング',
    'CSRemoteControl': 'リモート制御',
    'CSFileManager': 'ファイル転送',
    'modifyInformation': '情報修正',
    'useFunction': 'PC再起動/終了/削除',
    'viewReport': '統計/履歴を見る',
    'CSRemoteView': 'リモートビュー',
    'CSDeviceManagement': 'リモートデバイス名修正/削除',
    'CSUpdate': 'リモートデバイス更新',
    'CSThumbnailView': 'サムネイルビュー',
    'CSRestart': 'PC再起動'
  },
  'getin_with': {
    'internet_search': 'インターネット検索',
    'recommendation': '知人の推薦',
    'advertising': '広告/新聞/メディア',
    'sns': 'SNS/ブログ',
    'pcany': 'PCAny有料顧客',
    'etc': 'その他'
  },
  'added_device_in_group': 'リモートデバイスがグループに追加されました。',
  'removed_device_in_group': 'リモートデバイスがグループから削除されました。',
  'changed_group_info': 'グループ情報が変更されました。',
  'remote': {
    'remote': {
      'title': 'リモート制御',
      'title2': 'リモート制御',
      'desc': 'リモートデバイス接続を開始します。',
      'desc_mac': 'リモート制御を開始しますか？<br>(初回起動時にプログラムをインストールしてください)',
      'activex': 'しばらくするとランチャーが実行されます。',
      'activex_error': 'ActiveXの実行に失敗しました。',
      'download': 'ランチャーをダウンロードしたら実行してください。',
      'launch': 'しばらくするとランチャーが実行されます。未インストールの場合はインストーラーがダウンロードされます。',
      'application': 'しばらくするとアプリランチャーが実行されます。',
      'error': 'ランチャーの実行に失敗しました。',
      'urlscheme': 'しばらくするとプログラムが実行されます。'
    },
    'transfer': {
      'title': 'ファイル転送',
      'desc': 'ファイル転送を開始しますか？',
      'activex': 'しばらくするとランチャーが実行されます。',
      'activex_error': 'ActiveXの実行に失敗しました。',
      'download': 'ランチャーをダウンロードしたら実行してください。',
      'launch': 'しばらくするとランチャーが実行されます。未インストールの場合はインストーラーがダウンロードされます。'
    },
    'reboot': {
      'title': 'システム再起動',
      'desc': '※該当リモートデバイスで自動実行/ログイン機能が無効な場合、リモート接続はできません。リモートデバイスを再起動しますか？',
      'requested': '再起動が要求されました。'
    },
    'restart': {
      'title': 'リモートデバイス再起動',
      'desc': 'リモートデバイスプログラムを再起動します。',
      'requested': 'リモートデバイスの再起動が要求されました。'
    },
    'shutdown': {
      'title': 'システム終了',
      'desc': '※システムが終了した場合、オフライン状態に切り替わりリモート接続はできません。リモートデバイスのシステムを終了しますか？',
      'requested': 'システム終了が要求されました。'
    },
    'preview': {
      'title': 'スクリーンショット'
    },
    'detail': {
      'title': '詳細情報'
    },
    'logoff': {
      'title': 'リモートデバイスログオフ'
    },
    'delete': {
      'title': 'リモートデバイス削除'
    },
    'wol': {
      'title': 'WOL 電源オン',
      'desc': '「{device}」デバイスを次のデバイスでWOLを使用して起動します。デバイスを選択してください。',
      'success': 'WOL信号を送信しました。'
    },
    'approve': {
      'title': '制御権なし',
      'desc': 'リモート申請'
    },
    'web': {
      'title': 'リモート制御（ウェブビューア）'
    },
    'normal': {
      'title': 'リモート制御（ノーマルビューア）'
    }
  },
  'columns': {
    'alive': '状態',
    'actions': '機能',
    'alias': 'リモートデバイス名',
    'memo': 'メモ',
    'last_connected_time': 'リモートデバイスログイン日時',
    'group': 'グループ',
    'connect': '接続'
  },
  'id_exist': '既に存在するIDです。',
  'reserved': {
    'ROOT': 'デフォルトグループ'
  },
  'audit-message': {
    '1': 'リモート制御機能を実行しました。',
    '2': 'ファイルマネージャ機能を実行しました。',
    '3': 'システムを再起動しました。',
    '4': 'システムを終了しました。',
    '5': 'リモートデバイスを最新バージョンに更新しました。',
    '11': 'リモートデバイスの名前を「{old_value}」から「{new_value}」に変更しました。',
    '12': 'リモートデバイスのメモを「{old_value}」から「{new_value}」に変更しました。',
    '21': '「{old_value}」から「{new_value}」にグループを移動しました。',
    '30': '「{old_value}」から「{new_value}」に変更しました。',
    '31': '予約（オン）：{new_value}を追加しました。',
    '32': '予約（オフ）：{new_value}を追加しました。',
    '33': '予約（オン）：{new_value}番目の設定を削除しました。',
    '34': '予約（オフ）：{new_value}番目の設定を削除しました。',
    '35': 'リモコン：{new_value}を実行しました。'
  },
  'response_error_server_error': 'データを読み込む際に一時的なエラーが発生しました。しばらくしてから再試行してください。',
  'response_error_connect_failed': 'サーバーに接続できません。しばらくしてから再試行してください。',
  'not_supported_os': 'サポートされていないオペレーティングシステムです。',
  'alert_license': 'ライセンス期限切れ通知',
  'need_license': '{v}ライセンスが必要です。',
  'invalid_id_and_pw': 'IDとパスワードを確認してください。',
  'login_failed_cause_step1': 'IDとパスワードを確認してください。',
  'login_failed_cause_step2': 'メール認証が完了していません。<br>認証メールが届いていない場合は、認証メール再送信ボタンを押してください。',
  'login_failed_cause_flag_active': 'アカウントが無効化されています。<br>担当者にお問い合わせください。',
  'login_failed_cause_superadmin': '外部アクセスは制限されています。',
  'invalid_id': '有効なIDを入力してください。',
  'invalid_otp': 'OTP認証コードが間違っています。再入力してください。',
  'otp_token_expired': 'OTP認証の有効期限が切れました。再度ログインしてください。',
  'name_requirement': '名前を入力してください。',
  'phone_requirement': '電話番号を入力してください。',
  'emile_requirement': 'メール形式で入力してください。',
  'subspath_requirement': '加入経路を入力してください。',
  'company_name_requirement': '会社名を入力してください。',
  'digit_n_requirement': 'デジタル数字{v}桁を入力してください。',
  'dont_show_again': '再表示しない',
  'signup_done': '会員登録完了',
  'free_trial_message': '<strong>デバイス1台、15日間無料</strong>今すぐリモート制御LinkMeMineを<br>存分にご利用ください。',
  'enter_old_password': '現在のパスワードを入力',
  'enter_new_password': '新しいパスワードを入力',
  'search_location': '地域名を検索してください。',
  'accessable_user_desc': '該当グループのリモートデバイスアクセス権限を持つ下位ユーザー一覧です。',
  'password_requirement': 'パスワードは英文字、特殊文字、数字を混合して8～12文字以内で入力してください。',
  'password_confirm': 'パスワードが一致しません。',
  'password_modify_mail_sent': 'パスワード変更メールが送信されました。',
  'password_modified': 'パスワードが変更されました。',
  'password_modified_failed': 'パスワード変更に失敗しました。',
  'otp_reset_complete': 'OTPがリセットされました。',
  'otp_reset_failed': 'OTPのリセットに失敗しました。',
  'password_reset_desc': 'パスワードをリセットしてください。',
  'forgot_desc': 'IDを探す、またはパスワードをリセットすることで解決できない場合は、<br>' +
    'カスタマーセンターにメールでお問い合わせください。<br>' +
    '\'お問い合わせ\'をクリックしてお問い合わせページに移動するか、' +
    '<br>Support@linkmemine.comまでメールでお問い合わせください。',
  'expired_desc': '引き続きご利用いただくには、既存のライセンスを更新するか、<br>削除するデバイスを選択してください。',
  'expired_user_desc': 'ライセンスの有効期限が切れているため、ご利用いただけません。<br>管理者を通じてライセンスを更新するか、超過しているリモートデバイスを削除してください。',
  'email-invalid': '正確なメールアドレスを入力してください。',
  'id-invalid': '正確なIDを入力してください。',
  'navigate_to_home': 'ホームに移動する',
  'email_verification_success': 'メール認証に成功しました',
  'email_already_verified': 'このメールアドレスは既に認証されています',
  'email_verification_failed': 'メール認証に失敗しました',
  'email_verification_pending': 'メール認証を処理中です...',
  'email-auth-wait': 'メール認証中です。<br>しばらくお待ちください。',
  'email-auth-already': 'メール認証は既に完了しています。',
  'email-auth-fail': 'メール認証に失敗しました。',
  'email-auth-success': 'メール認証に成功しました。<br>ログインしてください。',
  'login_description': 'お持ちのすべてのPC、スマートデバイス、IoT機器に接続できます。',
  'join_description': 'LinkMeMineへの会員登録を歓迎します。<br>会員登録後、登録したメールに送信される認証メールをご確認ください。',
  'go_login': 'ログインへ進む',
  'your_email_is': 'このIDは登録済みのIDです。',
  'not_matched_user': '一致するユーザーが見つかりません。',
  'is_pcany_customer': '現在、PCAnyの有料顧客ですか？',
  'add_manager_desc': `
    <div>1. サブユーザーアカウントは、別途のメール認証なしで作成後すぐに使用できます。</div>
    <div>2. サブユーザーアカウントでログインしたリモートデバイスは管理者アカウントに帰属して表示されます。</div>
    <div>3. 各サブユーザーに対して権限設定およびアクセス可能なリモートデバイスグループの設定が可能です。</div>
  `,
  'free_trial_comment': '無料体験中です。サービスを延長してください。',
  'secure_login_desc': 'もしセキュリティコード6桁が確認できない場合は、<br>カスタマーセンターにご連絡ください。',
  'payment_tax_desc1': 'メールお問い合わせ: support@linkmemine.com',
  'payment_tax_desc2': '電子決済のお問い合わせ: 1544-7772(トスペイメント)',
  'payment_tax_desc3': 'お問い合わせ先: カスタマーサポート 02-839-7500(2番)<br>support@linkmemine.com',
  'payment_tax_desc4': 'エージェント数量および製品タイプを変更する場合は、ライセンス追加ボタンを押して申請してください。',
  'not_email_auth': '認証メールを送信しました。<br>メールをご確認ください。',
  'email_send_fail': 'メール送信に失敗しました。メールアドレスを確認してください。',
  'mobile_store': `
    モバイルリモート制御は、<br>
    アプリケーションをご利用ください。<br><br>
    <a href="{url}" target="_blank">ストアに移動</a>
  `,
  'OTP_desc': 'Webマネージャログイン時にGoogle OTPを使用して2段階認証を行います。',
  'agreement': {
    'desc': '利用規約および個人情報収集・利用に同意してください。',
    'agree_all': 'すべてに同意します',
    'agree_use': '利用規約に同意します',
    'agree_use_context': `
      [サービス利用規約]
      第1条（目的）
      この規約は、株式会社リンクミーマイン（以下、「リンクミーマイン」または「linkmemine.com」といいます）が運営するインターネットウェブサイトで提供されるインターネット関連サービス（以下「サービス」といいます）を利用するにあたり、リンクミーマインサービスと利用者の権利、義務、および責任事項を定めることを目的とします。
      第2条（定義）
      ① リンクミーマインサービスとは、コンピュータなどの電子通信設備を利用して、利用者に有益な各種情報を提供するインターネットウェブサイト上の関連サービスを指します。また、インターネットウェブサイトを運営する事業者としての意味も含まれます。② 「サービス」とは、本規約第4条に基づき、リンクミーマインサービスのウェブサイトを通じて利用者に提供される無料または有料の行為、またはその対象となる有形・無形の物自体を指します。③ 「利用者」とは、リンクミーマインサービスが運営するウェブサイトにアクセスし、本規約に従ってリンクミーマインが提供するサービスを受ける会員および非会員を指します。④ 「会員」とは、リンクミーマインが運営するウェブサイトに個人情報を提供して会員登録を行い、IDを付与された個人を指します。これにより、リンクミーマインの情報を継続的に提供され、サービスを継続的に利用することができます。⑤ 「非会員」とは、「会員」以外の個人を指します。
      第3条（規約の明示と改定）
      ① リンクミーマインサービスは、本規約の内容、商号、営業所所在地、代表者名、事業者登録番号、連絡先（電話、FAX、電子メールアドレスなど）を利用者が分かるようにリンクミーマインサービスの初期画面に掲示します。② リンクミーマインサービスは、約款の規制等に関する法律、電子商取引基本法、電子署名法、情報通信網利用促進等に関する法律、訪問販売等に関する法律、消費者保護法など関連法に違反しない範囲で、本規約を改定することができます。③ リンクミーマインサービスは、規約を改定する場合、適用日および改定理由を明示し、現行規約とともに初期画面にて、適用日の7日前から適用日まで告知します。④ リンクミーマインサービスが規約を改定した場合、その改定規約は適用日以降に締結された契約にのみ適用され、それ以前に締結された契約には改定前の規約がそのまま適用されます。ただし、既存の利用者が改定規約の適用を希望する場合、第③項に基づく改定規約の告知期間内にリンクミーマイン管理者に意思を伝え、管理者の同意を得た場合には、改定規約が適用されます。⑤ 会員は、変更された規約内容に同意しない場合、サービスの利用を中止し、会員登録を解約することができます。ただし、改定規約の適用日以降に一定期間サービスを継続して利用する場合、その会員は規約の変更に同意したものとみなされます。⑥ 本規約に定めのない内容および本規約の解釈については、関係法令または慣例に従います。
      第4条（サービスの提供および変更)
      ① リンクミーマインサービスは次の業務を遂行します: 1. プログラムまたはアプリケーションサービスに関する情報提供 2. 各種有用な情報の提供 3. 広告、イベント、商品またはサービスに関連する様々な販売促進活動 4. その他、利用者に有益な付加サービスおよびリンクミーマインサービスが定める業務 ② リンクミーマインサービスは、商品の品切れや技術的仕様の変更などの場合、将来締結される契約に基づき提供する商品・サービスの内容を変更することがあり、その場合、変更されたサービスの内容および提供日を明示し、現在のサービス内容を掲示している場所に告知します ③ リンクミーマインサービスが、利用者との契約に基づき提供するサービス内容を、商品の品切れや技術的仕様の変更などの理由で変更する場合、これにより利用者が被った損害を賠償しますが、リンクミーマインサービスに故意または過失がない場合はその責任を負いません。
      第5条（サービスの中断)
      ① リンクミーマインサービスは、コンピュータなどの情報通信設備の保守点検・交換および故障、通信の遮断などの理由が発生した場合、サービスの提供を一時的に中断することがあります。② 第1項によるサービス中断の場合、リンクミーマインサービスは第8条に定めた方法で利用者に通知します。③ リンクミーマインは、第1項の理由でサービス提供が一時的に中断され、これにより利用者または第三者が被った損害について賠償します。ただし、リンクミーマインに故意または過失がない場合、その責任を負いません。
      第6条（会員登録)
      ① 利用者は、会員登録が無料であり、リンクミーマインが定めた登録フォームに従って会員情報を記入し、本約款に同意する意思表示をすることで会員登録を申請します。② 第1項に基づき会員登録を申請した利用者のうち、次の各号に該当しない場合に限り、会員として登録されます。1. 登録申請者が本約款第7条第4項により以前に会員資格を喪失したことがある場合（ただし、第7条第4項に基づく会員資格喪失後3年が経過した者は除く）2. 登録内容に虚偽、記載漏れ、誤記がある場合 3. その他、会員として登録することがリンクミーマインサービスの技術的に著しく支障があると判断される場合 ③ 会員登録フォーム作成時にメール確認手続きを経て会員として登録されます。④ 会員登録契約の成立時期は、リンクミーマインの承諾が会員に到達した時点とします。⑤ リンクミーマインの会員は、会員登録と同時に「会員」資格を取得し、リンクミーマインが提供する様々なサービスを利用できます。⑥ リンクミーマインの会員は、会員登録時に登録したメールアドレスでリンクミーマインサイトに自由にアクセスでき、リンクミーマインサイトにアクセスすると、IDによる承認手続き後に利用できます。⑦ 会員は、登録した会員情報に変更がある場合、直ちにリンクミーマインが定める方法に従い、その変更事項をリンクミーマインに通知または修正しなければなりません。
      第7条（会員退会および資格喪失)
      ① 会員はリンクミーマインにいつでも退会を申請することができ、会員が退会を申請した場合、リンクミーマインは直ちに退会に必要な措置を講じます。② 会員が次の各号に該当する場合、リンクミーマインは会員に対し一定のサービス利用を制限したり、一定期間会員資格を停止することがあります。1. 登録申請時に虚偽の内容を記載した場合 2. リンクミーマインサービスを利用して購入した商品・サービスなどの代金やその他リンクミーマインサービス利用に関する会員が負担する債務を期限内に履行しない場合 3. 他人のIDおよびパスワードまたはその個人情報を盗用した場合 4. リンクミーマインサービスの利用を妨害したりその情報を盗用し、他人の名誉を毀損または不利益を与える行為など電子取引秩序を脅かす場合 5. リンクミーマインサービス画面にわいせつな内容を掲載したり、わいせつサイトにリンクを設定した場合 6. リンクミーマインサービスを利用して法令や本約款が禁止する行為または公序良俗に反する行為を行った場合 7. その他、サービス運営を故意に妨害する行為を行った場合 ③ リンクミーマインが会員資格を制限・停止した後、同様の行為が2回以上繰り返されるか、30日以内にその理由が是正されない場合、リンクミーマインは会員資格を喪失させることができます。④ リンクミーマインが会員資格を喪失させる場合には、会員登録を抹消します。この場合、会員にその旨を通知し、会員登録抹消前に弁明の機会を付与します。
      第8条（会員への通知)
      ① リンクミーマインは会員に通知を行う場合、会員がリンクミーマインに提出した電子メールアドレスを通じて行うことができます。② リンクミーマインは不特定多数の会員に対する通知の場合、リンクミーマイン掲示板に1週間以上掲示することで個別通知に代えることができます。
      第9条（IDサイトの規約適用)
      リンクミーマインが運営するインターネットウェブサイト（"linkmemine.com"）サイトのサービス利用時には、当該サイトの利用規約が適用されます。
      第10条（個人情報保護)
      ① リンクミーマインは利用者の情報を収集する際、サイト運営に必要な事項のみを必須項目とし、それ以外の事項は任意項目とします。② リンクミーマインが利用者を個人識別できる個人情報を収集する際には、必ず該当利用者の同意を得なければなりません。③ 提供された個人情報は、該当利用者の同意なしに目的外で利用したり、第三者に提供することはできず、これに関する全責任はリンクミーマインが負います。ただし、以下の場合は例外とします。1. 配送業務上、配送会社に配送に必要な最低限の利用者情報（氏名、住所、電話番号）を知らせる場合 2. 統計作成、学術研究または市場調査のために必要な場合で、特定の個人を識別できない形式で提供する場合 ④ リンクミーマインが第②項および第③項に基づき利用者の同意を得なければならない場合には、個人情報管理責任者の身元（所属、氏名、電話番号その他の連絡先）、情報の収集目的および利用目的、第三者への情報提供関連事項（提供先、提供目的および提供する情報の内容）を情報通信網利用促進および情報保護等に関する法律第22条第2項で規定された事項を事前に明示または告知しなければならず、利用者はいつでもこの同意を撤回することができます。⑤ 利用者はいつでもリンクミーマインが保有する自身の個人情報に対して閲覧および誤りの訂正を要求することができ、リンクミーマインはこれに対し速やかに必要な措置を講じる義務を負います。利用者が誤りの訂正を要求した場合、リンクミーマインはその誤りを訂正するまで該当個人情報を利用しません。⑥ リンクミーマインは個人情報保護のため、管理者を限定してその数を最小化し、クレジットカード、銀行口座を含む利用者の個人情報の紛失、盗難、流出、改ざんなどによる利用者の損害についてすべての責任を負います。⑦ リンクミーマインまたはそこから個人情報を提供された第三者は、個人情報の収集目的または提供目的を達成した際には、当該個人情報を速やかに破棄します。⑧ リンクミーマインは以下の情報を、会社が実施する提供機関との提携サービスに利用します。1. 利用情報の範囲（氏名、住民登録番号、職業、電話番号など） 2. 提供機関の範囲 a. 保険サービス提携関連損害保険会社および生命保険会社 b. ID提携サイト間の共同マーケティング実施 c. その他付加サービス提供のための提携会社の業務遂行に必要な最低限の範囲 3. 個人情報管理責任者：リンクミーマイン管理者（メール support@linkmemine.com）
      第11条（リンクミーマインサービスの義務)
      ① リンクミーマインサービスは、法令および本約款で禁止されている行為や公序良俗に反する行為をせず、本約款で定められた内容に基づいて継続的かつ安定的にサービスを提供するため最善を尽くします。② リンクミーマインサービスは、利用者が安全にインターネットサービスを利用できるよう、利用者の個人情報（信用情報を含む）を保護するためのセキュリティシステムを整備しなければなりません。③ リンクミーマインサービスは、商品または役務に関し、「表示・広告の公正化に関する法律」第3条に規定された不当な表示・広告行為を行ったことで利用者が損害を被った場合、その損害を賠償する責任を負います。④ リンクミーマインサービスは、受信拒否の意思を明確に示した利用者に対して、営利目的の広告性電子メールを送信しません。
      第12条（会員のIDおよびパスワードに関する義務)
      ① 第10条の場合を除き、IDおよびパスワードの管理責任は会員にあります。② 会員は自分のIDおよびパスワードを第三者に利用させてはなりません。③ 会員が自分のIDおよびパスワードを盗まれた、または第三者が使用していることを認識した場合、直ちにリンクミーマインに通知し、リンクミーマインの案内がある場合にはそれに従う必要があります。
      第13条（利用者の義務)
      利用者は以下の行為を行ってはなりません。1. 申請または変更時に虚偽の内容を登録する行為 2. リンクミーマインに掲載された他の情報を変更する行為 3. リンクミーマインが定めた情報以外の情報（コンピュータプログラムなど）を送信または掲示する行為 4. リンクミーマインサービス外の第三者の著作権など知的財産権を侵害する行為 5. リンクミーマインサービス外の第三者の名誉を毀損または業務を妨害する行為 6. わいせつまたは暴力的なメッセージ・画像・音声など、公序良俗に反する情報をモールに公開または掲示する行為
      第14条（リンクミーマインサービスと接続された「サイト」との関係)
      ① リンクミーマインと連携された「ウェブサイト」とは、ハイパーリンク（例：ハイパーリンクの対象には文字、画像、およびアニメーションなどが含まれる）方式などで接続されている場合を指します。② リンクミーマインは、連携された「ウェブサイト」が独自に提供する財貨・サービスに基づいて利用者との間で行われる取引について保証責任を負いません。
      第15条（著作権の帰属および利用制限)
      ① リンクミーマインが作成した著作物に関する著作権その他の知的財産権はリンクミーマインに帰属します。② 利用者は、リンクミーマインサービスを利用して得た情報を、リンクミーマインの事前の承認なしに複製、送信、出版、配布、放送、その他の方法により営利目的で利用または第三者に利用させてはなりません。
      第16条（免責)
      ① リンクミーマインサービスは、天災地変、不可抗力、その他合理的な制御範囲を超える理由によりサービスを提供できない場合、その責任を負いません。② リンクミーマインサービスは、利用者の責任によりサービスを提供できない場合、その責任を負いません。③ リンクミーマインサービスは、利用者がサービスを利用することによって期待される利益を得られなかった場合や、サービスを通じて得た資料を利用して発生した損害について責任を負いません。④ 利用者が画面に掲載した情報、資料、事実などの内容の信頼性や正確性については、当該利用者が責任を負い、リンクミーマインサービスは内容の不正確または虚偽により利用者または第三者に発生した損害について一切責任を負いません。⑤ リンクミーマインサービスは、サービス利用に関連して利用者の故意または過失により利用者または第三者に発生した損害について一切責任を負いません。
      第17条（広告掲載など)
      ① リンクミーマインは、利用者に最適なサービスを円滑に提供するため、商業広告を画面に掲載したり、メールまたはDM（手紙）などを利用して個別の利用者に送信することがあります。ただし、受信拒否の意思を明確に示した利用者には、それ以上メールまたはDM（手紙）などを送信しません。② リンクミーマインは、本サービスを通じた広告主の販売促進活動に会員が直接参加することによって発生した損害について責任を負いません。
      第18条（紛争解決)
      ① リンクミーマインは、利用者から提起される正当な意見や不満を反映し、その被害を補償するために被害補償処理機構を設置・運営します。② リンクミーマインは、利用者から提出される不満事項および意見を優先的に処理します。ただし、迅速な処理が困難な場合には、その理由と処理予定を速やかに利用者に通知します。③ リンクミーマインは、利用者間で発生した紛争については、電子取引基本法第28条および同施行令第10条に基づいて設置された電子取引紛争調整委員会の調整に従うことができます。
      第19条（裁判権および準拠法)
      ① リンクミーマインと利用者間で発生した電子取引に関する紛争の訴訟は、民事訴訟法に基づく管轄裁判所に提起します。② リンクミーマインと利用者間で提起された電子取引訴訟には、大韓民国の法律が適用されます。
      (付則)
      本約款は2016年4月1日から施行します。
    `,
    'agree_privacy': '個人情報の収集/利用に関する同意',
    'agree_privacy_context': `
      [リンクミマイン個人情報の収集/利用に関する同意]

      1. 収集する個人情報の項目
      2. 個人情報の収集別利用目的
      3. 個人情報の保有および利用期間
      

      1. 収集する個人情報の項目
      '사이트'は会員登録なしで利用できるコンテンツと、リモートサポートのためのサービス登録後に利用できるコンテンツで構成されています。
      'サイト'の会員制サービスを利用する場合、以下の情報を入力する必要がありますが、選択項目を入力しない場合でもサービス利用に制限はありません。
      1) 会員登録時に収集する個人情報の範囲
      - ID（メールアドレス）、名前、電話番号、生年月日、メール受信の有無
      
      
      
      2. 個人情報の収集ごとの利用目的
      ① 'サイト'は以下の目的で個人情報を収集しています。
      - 氏名、ID、パスワード：会員制サービス利用に伴う本人確認手続きに使用
      - メールアドレス、電話番号：通知事項の伝達、本人意思確認、苦情処理など円滑な意思疎通のための経路の確保、新しいサービス、新商品やイベント情報など最新情報の案内
      - その他の選択項目（生年月日など）：個別カスタマイズサービスを提供するための資料
      
      ② ただし、利用者の基本的人権を侵害する恐れのあるデリケートな個人情報（人種及び民族、思想及び信条、出身地及び本籍地、政治的傾向及び犯罪記録、健康状態及び性生活など）は収集しません。
      
      
      3. 個人情報の保有及び利用期間
      
      ① お客様の個人情報は、以下のように個人情報の収集目的または提供目的が達成されると破棄されます。
      ただし、商法などの法令の規定により保存の必要がある場合には例外とします。
      - 会員登録情報の場合、会員登録を退会または会員から除名されたとき
      - 代金支払情報の場合、代金の完済日または債権消滅時効期間が満了したとき
      
      ② 上記の個人情報収集目的が達成されると即時破棄する原則にもかかわらず、以下のように取引関連の権利義務関係の確認などの理由で一定期間保有する必要がある場合には、電子商取引などでの消費者保護に関する法律などに基づいて一定期間保有します。
      - 契約または契約撤回などに関する記録：5年
      - 代金決済及び財貨等の供給に関する記録：5年
      - 消費者の苦情または紛争処理に関する記録：3年
      
      ③ お客様の同意を得て保有している取引情報などをお客様が閲覧を要求する場合、'サイト'は閲覧及び確認できるよう措置します。
    `
  },
  'help_otp': `
    <h5>Google OTPを利用した2段階認証設定</h5>
    <section style="margin:30px 0;">
      <h6>1. 2段階認証(OTP)を有効化</h6>
      <p style="margin-left: 12px;">有効化ボタンをクリックして緑色にして有効化します。<br>
      OTPリセットボタンをクリックします。</p>
    </section>
    <section style="margin:30px 0;">
      <h6>2. Google Playストア、またはApple App Storeから「Google OTP」をインストールします。</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>3. Google OTPを起動します。</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>4. LinkMeMine管理者からログアウト後、再度ログインを試みるとGoogle OTP登録画面が表示されます。</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>5. Google OTPアプリでバーコードスキャンを選択して登録します。</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>6. 認証番号6桁を入力してログインします。</h6>
    </section>`,
  'help_manager': `
    <h5>中間管理者権限とは？</h5><br>
    <b>中間管理者（承認者）</b> : ユーザー権限を含み、ユーザーのリモートコントロール承認要求を許可/拒否できる権限<br><br>
    <b>ユーザー（要求者）</b> : 管理者または中間管理者からリモートコントロール権限を承認され、リモートデバイスをリモートコントロールおよびモニタリングできる権限
  `,
  'help_vaccine': `
    <h5>プロセス/サービス ヘルプ</h5><br>
    <h6>
      設定したプロセス/サービス名（.exeを除外）を<br>入力してください。
    </h6>
    <h6 style="padding:0 0 20px 0;">（プロセス/サービスを使用しない場合は空白を入力してください）</h6>
  `,
  'help_os': `
    <h5>OSバージョン ヘルプ</h5><br>
    <h6 style="padding:0 0 20px 0;">
      使用するOSのバージョンを以下から確認して入力してください。<br>
    </h6>
    <table>
      <th>OS</th>
      <th style="padding-right:20px;">MajorVersion</th>
      <th>MinorVersion</th>
      <tr>
        <td>Window Server 2019</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window 10</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2016</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2012 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8.1</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2012</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window 7</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Vista</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Home Server</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2003</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP Professional x64 Edition</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window 2000</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">0</td>
      </tr>
    </table>
  `,
  'help_email': `
    <h5>Emailと電話番号を必ず入力する理由は？</h5><br>
    <div style="margin-left: 12px;">1. IDおよびパスワードの検索</div>
    <div style="margin-left: 12px;">2. 休眠およびロックされたアカウントの解除</div><br>
    これらの機能を利用するために必要です。
  `,
  'help_searchPW': `
    登録されたメールアドレスにパスワード再設定メールが送信されます。
  `,
  'ip_delete_all_warning': 'IPリストをすべて削除しますか？',
  'ip_delete_all': 'IP全削除',
  'ip_block_reject': `ブロックポリシーによりブロックされたIPです。<br>管理者にお問い合わせください。`,
  'ip_white_reject': `許可ポリシーによりブロックされたIPです。<br>管理者にお問い合わせください。`,
  'search_manager_200': `承認者が設定されました。`,
  'search_manager_405': `承認者のIDを確認してください。`,
  'search_approver_null': '空欄を入力すると管理者が承認者に自動設定されます。',
  'date_validate_error': '申請日を確認してください。',
  'approvals_reason': '申請理由を入力してください。',
  'search_approver_placeholder': '承認者IDを入力してください。',
  'approval-success': `
    アクセス権限リクエストが処理されました。
  `,
  'function-settings-desc01': '中間管理者およびユーザーのファイル送信機能を許可/ブロックします。',
  'blocking-settings-desc01': 'ブロックIPを登録してアクセスをブロックします。',
  'blocking-settings-desc02': '許可IPを登録して登録されたIPのみアクセスを許可します。',
  'function-submit': '機能設定が修正されました。',
  'blocking-submit': 'ブロック/許可設定が修正されました。',
  'blocking-super-settings-desc': 'アクセスIP管理設定を使用します。',
  'reset-pw-repeat': 'パスワードを初期化しますか？',
  'reset-pw-submit': 'パスワードが初期化されました。<br>パスワード: koino1807!',
  'registration-access': 'アクセス権限リクエストが承認完了されました。',
  'registration-reject': 'アクセス権限リクエストが却下されました。',
  'registration-access-error': '却下理由を入力するとアクセス権限リクエストを承認できません。',
  'registration-reject-error': '却下理由を入力してください。',
  'login_failed_cause_ip_reject': 'IP制限ポリシーによりブロックされました。',
  'login_failure_limit': 'ログイン失敗許容回数を超えました。<br>担当者に問い合わせるかメール認証してください。',
  'registration-approve': '処理する',
  'registration-reject-history': '承認履歴を却下しますか？',
  'help_ip_add': `
    <h5>IP追加ヘルプ</h5><br>
    <h6 style="font-weight:bold;">
      単一IP追加
    </h6>
    <h6 style="padding:0 0 20px 0;">入力された単一のIPアドレスのみが追加されます。</h6>
    <h6 style="font-weight:bold;">
      IP範囲追加
    </h6>
    <h6 style="padding:0 0 20px 0;">
      入力された開始アドレスと終了アドレスの間に含まれるIPアドレスが追加されます。<br>
      例) 192.168.0.0 ~ 192.168.0.255
    </h6>
    <h6 style="font-weight:bold;">
      サブネット追加
    </h6>
    <h6 style="padding:0 0 20px 0;">
      サブネットで分割されたIPアドレスが追加されます。<br>
      例) 192.168.32.0/24
    </h6>
    <h6 style="font-weight:bold;">
      Excelで追加
    </h6>
    <h6 style="padding:0 0 20px 0;">
      下の<span style="color:#38d2b8;font-weight:bold;">「Excelテンプレートダウンロード」</span>をクリックしてテンプレートをダウンロードし、
      内容を入力してアップロードしてください。<br><br>
      単一IPおよびサブネットIPで追加することができ、<br>
      開始アドレスにIPを入力し、終了アドレスは空欄にしてください。<br><br>
      範囲IPを追加する場合は開始アドレスと終了アドレスを入力してください。<br><br>
      正しく入力されたIPアドレスのみが追加されます。
    </h6>
  `,
  'ip_range_error':'IPアドレスを確認してください。<br><br>',
  'ip_range_blank':'IPアドレスを入力してください。',
  'ip_excel_no_file':'Excelファイルをアップロードしてください。',
  'user_in_group_add':'追加するユーザーIDを入力してください。',
  'user_in_group_no_exist':'存在しないユーザーです。',
  'user_in_group_overlap':'既にグループに属しているユーザーです。',
  'user_in_group_blank':'追加するユーザーIDを入力してください。',
  'user_in_group_add_success':'ユーザーがグループに追加されました。',
  'user_in_group_remove_success':'ユーザーがグループから削除されました。',
  'start_time_ch':'開始日を選択',
  'start_time_time':'開始時間を選択',
  'end_time_ch':'終了日を選択',
  'end_time_time':'終了時間を選択',
  'auth_failure_num_desc':'管理者が設定した回数以上ログインに失敗した場合、アカウントがロック状態に変更されます。',
  'auto_block_time':'リモート接続後、設定した時間以上使用しない場合、自動でリモートを終了します。',
  'os_version_desc':'ユーザーの接続環境をチェックし、ポリシー設定で上位バージョンのWindows接続のみを許可します。',
  'session_timie_desc':'リモート接続後、設定した時間を超過すると自動でリモートを終了します。（使用中でも強制終了）',
  'password_level_desc':'ユーザー作成時にパスワードの難易度を調整します。',
  'capture_desc':'中間管理者およびユーザーのリモート画面キャプチャおよび録画機能を許可/ブロックします。',
  'display_power_save_desc':'リモート中にリモートデバイスPCの画面スリープを防止/維持します。',
  'system_power_save_desc':'リモート中にリモートデバイスPCのシステムスリープを防止/維持します。',
  'security_agreement_desc':'セキュリティ誓約書に同意したユーザーのみが接続できるように設定します。',
  'function_settings_header':'* ポリシー管理: 管理者は中間管理者およびユーザーのリモート機能や接続環境など、一括適用されるポリシーを設定できます。',
  'vaccine_desc':'設定したプロセス/サービス名が実行中のユーザー環境でのみ接続を許可します。',
  'invalid_idle_time':'リモート接続のアイドル時間（分）を確認してください。',
  'invalid_session_time':'リモート接続の維持時間（分）を確認してください。',
  'invalid_block_num':'認証失敗許容回数（回）を確認してください。',
  'invalid_min_os_major':'メジャーOSバージョンを確認してください。',
  'invalid_min_os_minor':'マイナーOSバージョンを確認してください。',
  'password_modified_error':'既存のパスワードを確認してください。',
  'password_change_limit':'パスワードの使用期間が切れました。<br>パスワードを変更してください。',
  'password_expired_desc':'設定された期間が切れた場合、パスワードを変更しないとログインできません。',
  'self_unlock_desc':'ユーザーが本人認証を通じて直接アカウントのロックを解除できます。',
  'invalid_password_change_limit':'パスワードの最大使用期間（日）を確認してください。',
  'help_PWChangeLimit': `
    <h5>パスワード最大使用期間のヘルプ</h5><br>
    <h6 style="line-height:1em;">
      パスワードを使用できる最大期間を設定します。<br>
      最大365日（1年）まで設定できます。<br>
    </h6>
    <h6 style="padding:20px 0 0 0;">
      （パスワード最大使用期間を使用しない場合は0を入力）
    </h6>
  `,
  'excel_onloaded':'正しく記載されたサブユーザーのみ表示されます。<br>登録するサブユーザーを選択して登録ボタンを押してください。',
  'excel_user_submit':'失敗 {failure}件を除くすべてのアカウント情報が一括登録されました。',
  'excel_group_submit':'失敗 {failure}件を除くすべてのグループ情報が一括登録されました。',
  'excel_group_fail':'グループ情報の一括登録に失敗しました。<br>Excelファイルに記載された情報を確認してください。',
  'groups':'グループ',
  'users':'ユーザー管理',
  'dashboard':'統計/履歴',
  'payment_manage':'決済',
  'subscription':'ライセンス追加/更新',
  'payment_history':'決済履歴',
  'deleted_device_history':'リモート機器削除履歴',
  'add_sub_user':'サブユーザー追加',
  'add_group':'グループ追加',
  'access_time':'接続時間',
  'no_devices':'リモート機器',
  'add_ip':'IP追加',
  'delete_ip':'IP削除',
  'add_ip_single':'単一IP追加',
  'add_ip_range':'IP範囲追加',
  'add_ip_subnet':'サブネット追加',
  'add_ip_excel':'Excelで追加',
  'device_excel_fail':'リモート機器リストのEXCEL生成に失敗しました。',
  
  'mode_simple':'SIMPLE',
  'mode_normal':'NORMAL',
  'mode_change':'モード切替',
  'mode_change_simple':'シンプルモード',
  'mode_change_normal':'ノーマルモード',
  'icon_access':'接続可能',
  'icon_online':'オンライン',
  'icon_offline':'オフライン',
  
  'agent_policy':'リモート機器ポリシー',
  'agent_restart_time':'リモート機器の定期再起動時間帯 (毎日)',
  'agent_restart_desc':'リモート機器の接続維持安定性向上のため、定期再起動時間帯を設定します。設定された時間帯に順次リモート機器が自動再起動およびサーバー自動再接続されます。業務に支障がないよう、使用量が少ない時間帯に設定することをお勧めします。登録されたリモート機器のうち、リモート接続が可能なオンライン状態のWindowsおよびAndroidリモート機器にのみ適用されます。',
  'agent_group_update':'リモート機器一括アップデート',
  'agent_group_desc':'登録されたリモート機器のうち、リモート接続が可能なオンライン状態のWindowsリモート機器が最新バージョンのリモート機器にアップデートされます。アップデートは順次適用され、アップデート完了後サーバー自動再接続されます。',
  'agent_update':'アップデート',
  'batch_update_desc':'最新バージョンのリモート機器に一括アップデートします。',
  
  'statistics_policy':'統計履歴周期設定',
  'statistics_period':'周期',
  'day':'日',
  'month':'月',
  'year':'年',
  
  'excel_button':'エクセル',
  'no-agent-selected':'選択されたリモート機器がありません。',
  
  'add-group-child':'グループ追加_サブグループ',
  'equipment_not_registered_msg':'登録された機器ではありません。',
  'max_device_limit_reached_msg':'許可されたデバイス登録数をすべて使用しました。<br>追加をご希望の場合は、既存のデバイスを削除してください。',
  'user_registered_agent':'本人が登録したリモート機器',
  
  'concurrent_users':'同時接続者',
  'max_device_alert':'ベーシックライセンスは{maxDevices}個を超えて登録できません。',
  'min_device_alert':'コーポレートライセンスは{minDevices}個未満で登録できません。',
  'min_concurrent_sessions_alert':'LMM1000+ライセンスは同時接続者を{minConcurrentSessions}以下で登録することはできません。',
  'addLicense':'決済する',
  'internal':'リモート管理',
  'external':'リモート接続',
  'payment_account_info': '<b>口座番号:</b> 1005-101-071339<br>\n' +
    '<b>銀行:</b> ウリ銀行<br>\n' +
    '<b>預金者:</b> 株式会社 コイノ<br>\n' +
    '<small>(入金確認はトクトク相談で行ってください)</small>',
  'password_reset_email_send': 'パスワード再設定メール送信',
  'in_progress_request': '申請中',
  
  'no_data_available': 'データがありません。',
  'agree_and_connect': '同意して接続',
  'decline_and_cancel': '拒否してキャンセル',
  'security_agreement': 'セキュリティ誓約書',
  'approval_type': '決済区分',
  'approval_line': '決済ライン',
  'application_reason': '申請理由',
  'manual_input': '手動入力',
  'pre_approval': '事前決済',
  'post_approval': '事後決済',
  'exception': '例外',
  'selection': '選択',
  'application_datetime': '申請日時',
  'remote_device_name': 'リモートデバイス名',
  'delete_registered_remote_device': '登録リモートデバイス削除',
  'confirm_delete_registered_device': '以下の登録されたリモートデバイスを削除しますか？',
  'device_deletion_logout_notice': '登録リモートデバイスを削除すると、リモートデバイスでログアウトされ<br>自動ログイン機能が解除されます。',
  'remote_device_registration_request': 'リモートデバイス登録申請',
  'memo': 'メモ',
  'registration_datetime': '登録日時',
  'step_n': '{n}段階',
  'apply': '適用',
  'user_kr': 'ユーザー',
  'policy_manager': '管理者',
  'mid_manager': '中間管理者',
  'admin_privileges': '管理者権限',
  'manager_name': 'マネージャー名',
  'delete_registered_manager': '登録マネージャー削除',
  'confirm_delete_registered_manager': '以下の登録されたマネージャーを削除しますか？',
  're_register_manager_approval_required': '削除されたマネージャーを再登録するには<br>マネージャー登録申請の決済が必要です。',
  'last_login_datetime': '最終ログイン日時',
  'add_user': 'ユーザー追加',
  'shared_group': '共有グループ',
  'approval_process': '決済',
  'select_delete': '選択削除',
  'recording': '録画',
  'success': '成功',
  'start_datetime': '開始日時',
  'end_datetime': '終了日時',
  'enter_content': '内容を入力してください。',
  'manager_str': 'マネージャー',
  'prior': '事前',
  'post': '事後',
  'category': '区分',
  'pledge_version': '誓約書バージョン',
  'error_code': 'エラーコード',
  'pledge': '誓約書',
  'start_date_str': '開始日付',
  'end_date': '終了日付',
  'toasts_message': {
    'key_is_required': '`{key}`は必須入力項目です。',
    'enum_error': '`{key}`は[{allowed_values}]のみ使用可能です。',
    'select_department_to_delete': '削除する部門を選択してください。',
    'excel_no_data': 'Excelにデータがありません。',
    'department_bulk_register': '失敗 {failure} 件を除くその他の部門情報が一括登録されました。',
    'select_file': 'ファイルを選択してください。',
    'no_data_to_download': 'ダウンロードするデータがありません。',
    'group_move_not_allowed': 'このグループは「全てのデバイス」グループです。グループ移動はできません。',
    'data_fetch_failed': 'データの取得に失敗しました。',
    'no_data_to_download_excel': 'Excelでダウンロードするデータがありません。',
    'no_selected_applicants': '選択された申請者がいません。',
    'approval_completed': '承認が完了しました。',
    'no_selected_department_members': '選択された部門所属メンバーがいません。',
    'remote_device_deleted': 'リモートデバイスが削除されました。',
    'version_applied': '該当バージョンが適用されました。',
    'save_success': '保存されました。',
    'manager_deleted': 'マネージャーが削除されました。',
    'select_user_to_delete': '削除するユーザーを選択してください。',
    'no_department_info': '部門情報がありません。',
    'required_field_message': '`{key}`は必須入力項目です。',
    'invalid_enum_value': '`{key}`は[{values}]のみ使用可能です。',
    'department_name_not_found': '存在しない部門名です。',
  },
  'join_form': {
    'required_field': '必須項目',
    'optional_field': '任意項目'
  },
  'login_page': {
    'popup_block': 'ポップアップブロッカーがポップアップをブロックしました。<br>ポップアップブロックを解除して、ページをリロードしてください。',
    'mobile_block': '一般のウェブブラウザではサービスを利用できません。<br>LinkMeMineモバイルアプリで接続してください。',
    'waiting': 'ユーザー環境検査とマネージャー登録状況を確認しています。<br>環境検査用EXEをダウンロードして実行してください。',
    'app_download': 'アプリダウンロード',
    'manual_download': '手動ダウンロード',
    'internal_tooltip': 'リモートデバイスをインストールおよび管理する際のマニュアルダウンロード',
    'external_tooltip': 'リモートデバイスがインストールされたデバイスをリモート接続する際のマニュアルダウンロード',
    'auto_login': '自動ログイン',
    'warning_massage1': '現在ログインを試みている端末は<br><em class="text-danger">既に登録申請が完了し、承認待ち状態です</em>',
    'warning_massage2': '登録をご希望の場合は申請時に<br>承認者として指定された管理者に承認を依頼してください。',
    'warning_massage3': '登録をご希望でない場合は申請時に<br>承認者として指定された管理者に差し戻しを依頼してください。',
    'download_android_remote_device': 'Androidリモートデバイスのダウンロード',
  },
  'department_page': {
    'add_department': '部門追加',
    'bulk_add_department': '部門一括追加',
    'department_delete': '部門削除',
    'department_manage': '部門管理',
    'department_name': '部門名',
    'department_created': '部門を作成しました。',
    'department_deleted': '部門を削除しました。',
    'confirm_department_delete': '該当部門を削除しますか？',
  },
  'device_page': {
    'public_access_warning': '公共場所での接続禁止警告',
    'default_group': 'デフォルトグループ',
    'update': '更新',
    'device_favorite_removed': '{alias}デバイスのお気に入りが解除されました。',
    'device_favorite_added': '{alias}デバイスがお気に入りに登録されました。',
    'device_moved_to_group': '`{alias}デバイスが{node.name}(さん)のグループに移動されました。`',
    'remote_device_list': 'リモートデバイスリスト',
    'self_registration': '自己登録',
    'remote_device_group_name': 'リモートデバイスグループ名',
    'remote_device_already_exists': '既に存在するリモートデバイスです。',
    'all_devices': 'すべてのデバイス',
    'self_registered_remote_device': '自己登録されたリモートデバイス',
  },
  'dialogs_page': {
    'security_pledge': 'セキュリティ誓約書',
    'security_pledge_desc': {
      "items": [
        "上述の本人は指定された勤務場所でリモート接続を実施します。",
        "本人はリモート接続中に閲覧、作成、保存、印刷した文書または情報を徹底的に管理し、それを外部に流出させません。",
        "本人はウイルス感染や拡散を防ぐため、リモート接続用コンピュータにウイルス対策プログラムをインストールし、最新の状態に保ちます。",
        "本人はリモート接続中にコンピュータの画面保護機能を設定し、画面復帰時には必ずパスワードを入力します。",
        "本人はリモート接続のために与えられたID、パスワード、およびセキュリティ情報を徹底的に管理し、外部に流出させないようにします。",
        "本人が与えられたID、パスワード、およびセキュリティ情報が外部に流出したことを認識した場合、直ちに使用停止申請を行い、再発行を受けます。",
        "本人は許可されていないファイル転送、画面キャプチャ、録画などの行為を一切行わず、必要な場合は適切なセキュリティ対策を整えて上位管理者に報告した後に実施します。"
      ],
      'confirmation': '本人は上述の事項を遵守し、それを違反した場合は規則および関連法令に従って処罰および不利益を受けることを誓約します。'
    },
    'remote_application_form': 'リモート申請書',
    'duplicate_error': '重複エラー',
    'change_start_date_and_retry': '開始日時を変更して再度申請してください。',
    'select_approval_line': '承認ラインを選択してください。',
    'application_info': '申請情報',
    'registered_remote_device_info': '登録済みリモートデバイス情報',
    'max_registration_allowed': '最大登録可能',
    'current_registration': '現在登録数',
    'registration_in_progress': '登録申請中',
    'exceeded_remote_device_limit': '登録可能なリモートデバイス数を超えました。',
    'remove_or_revoke_pending_requests': '現在登録されているリモートデバイスを削除するか<br>登録申請中の申請/承認案件を回収した後<br>再試行してください。',
    're_registration_requirements': 'また、削除されたリモートデバイスを再登録するには、リモートデバイスが<br>インストールされたローカルでプログラムを削除後<br>再インストール/ログイン/リモートデバイス登録申請および承認が必要です。',
    'remote_device_registration_exceeded': 'リモートデバイス登録申請超過',
    'enter_remote_device_name': 'リモートデバイス名を入力してください。',
    'remote_device_registration_completed': 'リモートデバイス申請が完了しました。',
    'approver_selection': '承認者選択',
    'approval_line_limit': '{limit}段階承認者まで必須選択後、承認ライン反映が可能です。',
    'user_environment_check_result': 'ユーザー環境検査結果',
    'inspection_item': '検査項目',
    'description': '説明',
    'result': '結果',
    'add_selection': '選択追加',
    'select_user_to_add': '追加するユーザーを選択してください。',
    'registered_manager_info': '登録済みマネージャー情報',
    'manager_registration_limit_exceeded': '登録可能なマネージャー数を超えました。',
    'remove_or_revoke_pending_manager_requests': '現在登録されているマネージャーを削除するか<br>登録申請中の申請/承認案件を回収した後<br>再試行してください。',
    'manager_registration_request': 'マネージャー登録申請',
    'manager_registration_request_exceeded': 'マネージャー登録申請超過',
    'enter_manager_name': 'マネージャー名を入力してください。',
    'manager_registration_completed': 'マネージャー申請が完了しました。',
    'send_email': 'メール送信',
  },
  'error_page': {
    'logout_completed': 'ログアウトしました。',
    'invalid_access': '不正なアクセスです。',
    'manager_registration_required': '未登録のマネージャーです。<br>マネージャー登録申請ポップアップで申請してください。<br>ポップアップウィンドウが表示されない場合はポップアップブロックを解除してください。<br>マネージャー登録申請および承認後<br>再接続してください。',
    'invalid_access_vpn': '不正なアクセスです。<br>VPNアプリで接続してください。',
    'session_expired': 'セッションの有効期限が切れました。',
    'manager_registration_success': 'マネージャー登録申請が完了しました。<br>マネージャー登録申請承認後<br>再接続してください。',
  },
  'groups_page': {
    'group_access_user_remote_device_list': 'グループアクセス権限ユーザーが登録したリモートデバイス一覧',
    'shared_group_management': '共有グループ管理',
    'duplicate_value_detected': '重複した値があります: ',
    'select_group_to_delete': '削除するグループを選択してください。',
    'group_deletion': 'グループ削除',
  },
  'management_page': {
    'requester': 'リクエスター',
    'approver': '承認者',
    'delete_device': 'デバイス削除',
    'enter_device_name': 'デバイス名を入力してください。',
    'remote_device_registration_history': 'リモートデバイス登録申請履歴',
    'application_date': '申請日',
    'application_time': '申請時間',
    'approval_datetime': '承認日時',
    'approval_status': '承認ステータス',
    'approval_date': '承認日',
    'approval_time': '承認時間',
    'final_approver': '最終承認者',
    'remote_device_registration_request_approval': 'リモートデバイス登録申請承認',
    'select_approval': '承認を選択',
    'confirm_remote_device_approval': '上記リモートデバイス登録申請について承認しますか？',
    'remote_device_integration_management': 'リモートデバイス統合管理',
    're_registration_requirements': '削除されたリモートデバイスを再登録するには、<br>リモートデバイス登録申請の承認が必要です。',
    'registration_date': '登録日',
    'registration_time': '登録時間',
    'deletion_datetime': '削除日時',
    'deletion_date': '削除日',
    'deletion_time': '削除時間',
    'remote_device_registration_deletion_history': 'リモートデバイス登録/削除履歴',
    'deleter': '削除者',
    'ip_management_policy': 'IP管理ポリシー',
    'block_blacklist_ip': '(ブロック-ブラックリスト方式) 登録された接続IPをブロック',
    'block_blacklist_disabled': '(ブロック-ブラックリスト方式) 使用しない',
    'start_ip_address': 'IPアドレス（開始）',
    'end_ip_address': 'IPアドレス（終了）',
    'approval_information': '承認情報',
    'no_approval_information': '承認情報がありません。',
    'pending': '未決',
    'approval_opinion': '承認意見',
    'remote_work': 'リモートワーク',
    'incident_response': '障害対応',
    'dispatch': '派遣',
    'maintenance': 'メンテナンス',
    'security_pledge_management': 'セキュリティ誓約書管理',
    'version_settings': 'バージョン設定',
    'enter_version': 'バージョンを入力してください。',
    'applied_version': '適用バージョン',
    'version_management': 'バージョン管理',
    'new_registration': '新規登録',
    'user_remote': 'ユーザーリモート',
    'user_remote_approval_process': 'ユーザーリモート（承認プロセス）',
    'user_remote_approval_policy_activation': 'ユーザーリモート（承認プロセス）ポリシーを有効化して<br>ユーザーごとの承認プロセス例外/適用設定を行うことができます。',
    'approval_process_applied_policy': '承認プロセスが適用されたユーザーは、<br>必ずリモート申請による承認後にリモート制御が可能です。（事前承認の場合）<br>事後承認権限を持つ承認プロセス適用ユーザーが事後承認でリモート申請する場合、<br>即時承認された権限を得てリモート制御が可能です。（事後承認として履歴管理）',
    'approval_process_usage': '① 使用：ユーザーごとの承認プロセス例外/適用設定可能',
    'approval_process_not_applied_to_existing_exceptions': '- 使用に切り替えても既存の承認プロセス例外ユーザーには適用されません',
    'approval_process_not_used': '② 未使用：全ユーザー承認プロセスなしでリモート接続',
    'approval_process_disabled_effect': '- 未使用に切り替えた場合、承認プロセスが適用されたユーザーも承認なしでリモート接続可能',
    'remote_and_connection_maintenance_policy': 'リモートおよび接続維持ポリシー',
    'remote_and_connection_policy_applies_to_all': 'リモートおよび接続維持ポリシーは、全システムおよびユーザーに適用されます。',
    'remote_control_file_transfer': '1. リモート制御、ファイル転送',
    'block_remote_control_file_transfer': '① ブロック：全ユーザーのリモート制御、ファイル転送機能をブロック',
    'block_applies_to_all_users': '- ブロックに切り替えた場合、既存権限を付与されたユーザーも機能がブロックされます',
    'allow_user_permissions': '② 許可：ユーザーごとに権限設定が可能',
    'allow_transition_no_access': '- 許可に切り替えても既存の権限が付与されていないユーザーは機能を利用できません',
    'system_user_bulk_apply': '2. 全システムおよびユーザーに一括適用される項目',
    'screen_capture_recording_lock': '- スクリーンキャプチャおよび録画、キーボードおよびマウスのロック、画面ブロック（ブラックスクリーン）',
    'screen_saver_power_saving': '- スクリーンセーバー、画面省電力、電源省電力',
    'forced_idle_logout_manager': '- 強制ログアウト（マネージャー）、アイドル状態で自動ログアウト（マネージャー）',
    'forced_idle_termination_viewer': '- 強制終了（ビューア）、アイドル状態で自動終了（ビューア）',
    'public_access_prohibited_warning': '公共の場での接続禁止警告',
    'accept_and_save': '承認して保存',
    'windows_process_service_detection': 'Windowsプロセスおよびサービス名で設定したプロセス/サービスが動作しているかを検知し、<br>動作中のユーザーリモート接続環境でのみリモート接続を許可します。',
    'add_excluding_exe': '追加（.exe除外）',
    'application_reason_approval_opinion_settings': '申請理由および承認意見設定',
    'enter_application_reason': '申請理由を入力してください',
    'enter_approval_opinion': '承認意見を入力してください',
    'recording_storage_path_validation': '録画映像ストレージパス検証',
    'storage_path_unreachable': '設定したストレージにアクセスできないか、パスが存在しません。',
    'storage_access_success': '設定したストレージにアクセス可能です。',
    'windows_antivirus_check_settings': 'Windowsアンチウイルスインストール/実行確認設定',
    'antivirus_process_name': 'アンチウイルスプロセス名<br>（.exe除外）',
    'antivirus_process_name_excluding_exe': 'アンチウイルスプロセス名<br>（.exe除外）',
    'antivirus_detection_by_process': 'アンチウイルスのインストールおよび動作をWindowsプロセス名で検知します。',
    'system_policy': 'システムポリシー',
    'system_policy_applies_to_all': 'システムポリシーは、全システムおよびユーザーに適用されます。',
    'approval_process_enabled': '① 使用：ユーザーごとの承認プロセス例外/適用設定可能',
    'approval_process_exception_unchanged': '- 使用に切り替えても既存の承認プロセス例外ユーザーには適用されません',
    'approval_process_disabled': '② 未使用：全ユーザー承認プロセスなしでリモート接続',
    'ip_management_enabled': '① 使用：管理-接続IP管理メニューを有効化し、ユーザーIPでブロック/許可が可能',
    'ip_management_disabled': '② 未使用：管理-接続IP管理メニューを無効化し、ユーザーIP接続を制御しません',
    'connection_maintenance_policy': '接続維持ポリシー',
    'forced_logout_manager': '強制ログアウト（マネージャー）',
    'web_app_manager_forced_logout': 'WEBおよびAPPマネージャーログイン時、設定時間後に強制ログアウト（設定値が0の場合、ポリシーは使用されません）',
    'idle_auto_logout_manager': 'アイドル状態で自動ログアウト（マネージャー）',
    'web_app_manager_idle_logout': 'WEBおよびAPPマネージャーログイン時、設定時間中に動作がない場合、自動ログアウト（設定値が0の場合、ポリシーは使用されません）',
    'forced_termination_viewer': '強制終了（ビューア）',
    'remote_connection_forced_termination': 'リモート接続時、設定時間後にリモートを強制終了（設定値が0の場合、ポリシーは使用されません）',
    'idle_auto_termination_viewer': 'アイドル状態で自動終了（ビューア）',
    'remote_connection_idle_termination': 'リモート接続時、設定時間中に動作がない場合、自動終了（設定値が0の場合、ポリシーは使用されません）',
    'statistics_history_cycle_settings': '統計履歴周期設定',
    'remote_policy': 'リモートポリシー',
    'remote_control': 'リモート制御',
    'block_allow': 'ブロック/許可',
    'remote_control_restriction': 'リモート制御機能のブロック / ユーザーごとの許可設定',
    'file_transfer_restriction': 'ファイル転送機能のブロック / ユーザーごとの許可設定',
    'screen_capture_recording_restriction': '画面キャプチャ機能および画面録画機能のブロック / 許可設定',
    'keyboard_mouse_lock': 'キーボードおよびマウスのロック',
    'not_applied_applied': '未適用/適用',
    'keyboard_mouse_lock_settings': 'リモート接続時、リモートデバイスPCのキーボードおよびマウスロック機能の未適用/適用設定',
    'screen_block_black_screen': '画面ブロック（ブラックスクリーン）',
    'screen_block_black_screen_settings': 'リモート接続時、リモートデバイスPCの画面ブロック（ブラックスクリーン）機能の未適用/適用設定',
    'screen_saver': 'スクリーンセーバー',
    'maintain_prevent': '維持/防止',
    'screen_saver_local_settings': 'リモート接続時、リモートデバイスPCのスクリーンセーバーローカル設定の維持/防止設定',
    'screen_power_saving': '画面省電力',
    'screen_power_saving_local_settings': 'リモート接続時、リモートデバイスPCの画面省電力ローカル設定の維持/防止設定',
    'power_saving': '電源省電力',
    'power_saving_local_settings': 'リモート接続時、リモートデバイスPCの電源省電力ローカル設定の維持/防止設定',
    'account_security_policy': 'アカウントセキュリティポリシー',
    'password_complexity': 'パスワードの複雑性',
    'user_remote_approval': 'ユーザーリモート承認',
    'disabled_enabled': '未使用/使用',
    'remote_request_and_approval': 'リモート申請および承認後にリモート接続機能を使用（ユーザーごとの承認プロセス例外/適用設定可能）',
    'manager_registration_approval': 'マネージャー登録承認',
    'manager_registration_with_approval': 'マネージャー登録時、承認後に登録機能を使用',
    'remote_device_registration_approval': 'リモートデバイス登録承認',
    'remote_device_registration_with_approval': 'リモートデバイス登録時、承認後に登録機能を使用',
    'internal_network_admin_ip_management': 'ポリシー管理者の内部ネットワーク管理者WEB接続IP管理機能を使用（外部ネットワークポリシー管理者、内部ネットワーク承認者、内部ネットワーク例外ユーザー、外部/内部ネットワーク一般ユーザーには制限なし）',
    'windows_version_check': 'Windowsバージョン確認',
    'windows_version_restriction': '設定されたWindowsバージョン以上のユーザー接続環境でのみリモート接続を許可',
    'windows_auto_update_check': 'Windows自動更新確認',
    'windows_auto_update_activation_check': 'リモート接続開始時、Windows自動更新設定が有効であることを確認してリモート接続を許可',
    'windows_antivirus_installation_execution_check': 'Windowsアンチウイルスインストール/実行確認',
    'antivirus_installation_execution_restriction': '設定されたアンチウイルスのインストールおよび実行が確認されたユーザー接続環境でのみリモート接続を許可',
    'windows_process_service_check': 'Windowsプロセス/サービス確認',
    'process_service_running_restriction': '設定されたプロセスおよびサービスが動作中のユーザー接続環境でのみリモート接続を許可',
    'or_higher': '以上',
    'manager_registration_request_history': 'マネージャー登録申請履歴',
    'manager_registration_request_approval': 'マネージャー登録申請承認',
    'approve_manager_registration_requests': '上記マネージャー登録申請について承認しますか？',
    'manager_integration_management': 'マネージャー統合管理',
    'manager_registration_deletion_history': 'マネージャー登録/削除履歴',
    'user_remote_request_approval': 'ユーザーリモート申請承認',
    'remote_request_approval': 'リモート申請承認',
    'user_remote_control_history': 'ユーザーリモート制御履歴',
    'remote_control_history': 'リモート制御履歴',
    'remote_control_history_self': 'リモート制御履歴（本人）',
    'user_remote_request_history': 'ユーザーリモート申請履歴',
    'remote_request_history': 'リモート申請履歴',
    'rejection_reason': '却下理由',
    'manager_management': 'マネージャー管理',
    'integration_management': '統合管理',
    'registration_request_approval': '登録申請承認',
    'registration_request_history': '登録申請履歴',
    'registration_deletion_history': '登録/削除履歴',
    'windows_process_service_check_settings': 'Windows プロセス / サービス確認設定',
  },
  'statistics_page': {
    'development_environment': '開発環境',
    'connection_datetime': '接続日時',
    'connection_environment': '接続環境',
    'user_login_history': 'ユーザーログイン履歴',
    'internal_network': '内部ネットワーク',
    'external_network': '外部ネットワーク',
    'login_date': 'ログイン日付',
    'login_time': 'ログイン時間',
    'remote_control_history_statistics': 'リモート制御履歴統計',
    'remote_control_connection_count': 'リモート制御接続回数',
    'connection_count': '接続回数',
    'manager_remote_control_by_os': 'マネージャーOS別リモート制御',
  },
  'support_page': {
    'remote_access_manual': 'リモートアクセスマニュアル',
    'remote_management_manual': 'リモート管理マニュアル',
    'delete_notice': 'お知らせ削除',
    'confirm_deletion': '本当に削除しますか？',
    'author': '作成者',
    'title': 'タイトル',
    'content': '内容',
    'register_notice': 'お知らせ登録',
    'enter_title': 'タイトルを入力してください',
  },
  'user_page': {
    'approver_management': '承認者管理',
    'bulk_update': '一括変更',
    'not_set': '未設定',
    'step': 'ステップ',
    'approval_step': '承認段階',
    'no_selected_items': '選択された項目がありません。',
    're_registration_requirements': 'また、削除されたリモートデバイスを再登録するには<br>ローカルでログインしてリモートデバイス<br>登録申請の承認が必要です。',
    'no_selected_remote_device': '選択されたリモートデバイスがありません。',
    'confirm_update_mid_manager_approval_step': '以下の中間管理者の承認段階設定を変更しますか？',
    'policy_manager_fixed_approval_step': 'ポリシーマネージャーの承認段階は「全体」に固定されており、変更事項は反映されません。',
    'approval_step_update': '承認段階設定変更',
    'select_approval_step': '承認段階を選択してください。',
    'department_members': '部署所属人数',
    'registered_manager': '登録されたマネージャー',
    'no_selected_manager': '選択されたマネージャーがありません。',
    'add_department_member': '部署員追加',
    'select_exclude': '選択除外',
    'confirm_user_exclusion': '以下のユーザーを{departmentName}から除外しますか？',
    'excluded_user_temp_department': '除外されたユーザーは無所属部署に一時移動されます。<br>ユーザーの部署変更はユーザー管理で行うことができます。',
    'exclude': '除外',
    'approval_process': '承認プロセス',
    'department_management_department_members': '部署管理部署所属人数',
    'post_approval_permission': '事後承認権限',
    'department_head': '部署長',
    'bulk_apply': '一括適用',
    'bulk_retrieval': '一括回収',
    'select_department_head': '部署長を選択',
    'department_member_management': '部署員管理',
    'members': '人数',
    'department_policy': '部署ポリシー',
    'registered_remote_device': '登録されたリモートデバイス',
    'exclude_department_members': '部署所属人数除外',
    'bulk_add_users': 'ユーザー一括追加',
    'enter_email': 'メールアドレスを入力してください',
    'enter_valid_email': '有効なメールアドレスを入力してください。最大40文字',
    'enter_password': 'パスワードを入力してください',
    'reenter_password': 'もう一度パスワードを入力してください',
    'position': '役職',
    'enter_position': '役職を入力してください',
    'enter_job_title': '職位を入力してください',
    'is_department_head': '部署長かどうか',
    'user_permissions': 'ユーザー権限',
    'self_approval_step': '自身承認段階',
    'mandatory_approval_step_for_use_request': '使用申請必須承認段階',
    'manager_limit': 'マネージャー上限',
    'remote_device_limit': 'リモートデバイス上限',
    'file_transfer_permission': 'ファイル転送権限',
    'global_settings': '全体設定',
    'basic_user_limit': 'Basicユーザーはサブユーザーを1人しか作成できません。',
    'dev_limit_warning': '現在のアカウントで登録可能なリモートデバイスの最大数は{maxValue}個です。<br/>リモートデバイスの上限を増やしたい場合、決済メニューからリモートデバイスの数を追加申請してください。',
    'user_details': 'ユーザー詳細',
    'apply_approval_process': '承認プロセス適用',
    'view_delete': '表示/削除',
    'manager_limit_exceeded': '設定しようとしている登録可能マネージャー上限が既に登録されているマネージャー数を下回っています。登録済みマネージャーを削除してから再試行してください。',
    'dev_limit_exceeded': 'ライセンスに登録されたリモートデバイスの使用量({totalDevLimit})を上回る量を入力しました。',
    'remote_device_limit_exceeded': '設定しようとしている登録可能リモートデバイス上限が既に登録されているリモートデバイス数を下回っています。登録済みリモートデバイスを削除してから再試行してください。',
    'work': '勤務',
    'resignation': '退職',
    'mandatory_approval_step': '必須承認段階',
    'designated_approver': '指定承認者',
    'status_changed': '{name}が{status}に変更されました',
    'registration_limit': '登録上限',
    'concurrent_sessions_allowed': '同時接続許可セッション',
  },
  'access_page': {
    'unknown_error_occurred': '不明なエラーが発生しました。再接続を試みてください。',
    'screen_saver_disabled': 'スクリーンセーバーが無効になっているか、「再開時にログオン画面を表示」オプションがオフになっています。',
    'start_required_process': '必須プロセスを実行してから、再接続を試みてください。',
    'install_and_run_antivirus': 'アンチウイルスをインストールして実行した後、再接続を試みてください。',
    'enable_windows_auto_update': 'Windowsの自動更新設定を有効にして、再接続を試みてください。',
    'comply_with_windows_policy': 'ユーザー接続環境ポリシーのWindowsバージョン要件を満たしてから、再接続を試みてください。',
    'missing_check_program': '環境設定チェックプログラムがダウンロードされていません。',
    'check_completed': '正常にチェックが完了しました。',
    'user_environment_check_program': 'ユーザー環境検査プログラムをダウンロードして実行してください。',
    'cannot_login_with_partner_id': 'パートナーIDでログインすることはできません。',
  },
  'environmentCheckError': {
    'unknown': "環境チェック中に不明なエラーが発生しました。",
    'environmentCheckFailed': "環境チェックに失敗しました。<br/> プログラムのエラー内容を確認してください。",
    'managerDevicePendingApproval': "マネージャーデバイスが承認待ち状態です。<br/> 承認後に変更してください。",
    'managerDeviceNotRegistered': "マネージャーデバイスが存在しません。<br/> マネージャーデバイスを登録してください。",
    'environmentCheckTimeout': "環境チェックの時間が超過しました。<br/> 環境チェックプログラムを実行してください。",
    'connectionError': "接続中に予期しないエラーが発生しました。"
  },
  "agent_installer_file": "エージェントインストーラーファイル",
  "agent_file_description": "同じアカウントでエージェントのインストールおよびログインまで自動で行われます。<br>複数のデバイスにエージェントをインストールするのに適しています。",
  "install_type": "インストール形式",
  "access_account_setting": "接続アカウント設定",
  "enter_password": "パスワードを入力してください",
  "access_permission_setting": "接続権限設定",
  "installer_file_expiration_date": "インストーラーファイルの有効期限",
  "select_expiration_date": "有効期限を選択",
  "proxy_server_setting": "プロキシサーバー設定",
  "proxy_server": "プロキシサーバー",
  "proxy_port": "プロキシポート",
  "proxy_id": "プロキシID",
  "proxy_password": "プロキシパスワード",
  "generate_installer_file": "インストーラーファイルを生成",
  "auto_login_install_mode": "自動ログインインストール方式",
  "manual_login_install_mode": "手動ログインインストール方式",
  "disabled": "使用しない",
  "manual_setting": "手動設定",
  "auto_setting": "自動設定",
  "login_failed_invalid_credentials": "ログインに失敗しました。IDまたはパスワードを確認してください。",
  "file_download_error": "ファイルのダウンロード中にエラーが発生しました。",
  "agent_auto_login_agreement_text": "LinkMeMineソフトウェア使用権契約およびカスタマーサポートサービス利用権\n\n本ソフトウェア製品はコンピュータプログラム保護法、著作権法、国際著作権条約、その他の知的財産関連法及び条約により保護されています。\n本ソフトウェア製品にはコンピュータソフトウェア、記録媒体、印刷物およびオンライン文書または電子文書が含まれ、本ソフトウェア製品と付随するすべての実行ファイル、追加機能、使用説明書、ヘルプファイル、その他のファイルを含みますが、これに限られません。「使用」とは、本ソフトウェア製品がコンピュータの主記憶装置または一時記憶装置（RAM、CD-ROM、その他のストレージ）に保存されている、またはインストール、実行、表示される行為を指します。\n\n第1条 ソフトウェア使用権およびカスタマーサポートサービス利用権\n\nお客様の権利は基本的にソフトウェアそのものの使用権および付随するサービスの利用権から構成されます。\n\nソフトウェア使用権：\nお客様は本ソフトウェア製品をコンピュータにインストールして使用することができます。\n本契約に違反するソフトウェア製品の複製または再配布は法律で禁じられており、重大な民事および刑事罰を受ける可能性があります。\n\nサービス利用権：\nサービスとは、遠隔地デバイスを登録し、PCまたはモバイルでリモート制御サービスを実行するために必要な各種設定サービスを指します。\n\n第2条 所有権\n\n本ソフトウェア製品に対する特許権、著作権、その他一切の知的財産権は株式会社LinkMeMineにあります。本ソフトウェア製品は販売されるものではなく、使用が許諾されるものです。したがって、所有権やその他の権利はお客様に移転されず、本契約による使用権の許諾は販売とは見なされません。ただし、本使用権契約の条件を遵守する場合に限り、バックアップまたは保管目的で本ソフトウェア製品の複製を1本作成することができます。それ以外の場合は追加の複製を作成することはできません。\n\n第3条 その他の権利および制限についての規定\n\nお客様は、関連法規で許可される範囲以外で本ソフトウェア製品をリバースエンジニアリング、デコンパイル、ディスアセンブルすることはできません。本契約で明示的に許可された場合を除き、すべての使用、複製、翻訳、再配布、再送信、出版、販売、貸与、賃貸、譲渡、質権設定、担保設定、変更、改造、拡張を行うことはできません。\n\n第4条 保証の制限\n\n保証期間：株式会社LinkMeMineは購入日から90日間、製品に物理的な欠陥がないことを保証します。保証期間中、製造上の欠陥がある場合は交換いたします。ただし、購入から90日以内であることが証明される必要があります。\n\n限定保証：本ソフトウェア製品の使用および性能に関するすべてのリスクはお客様が負担します。\n\n第5条 契約全体\n\n本契約はお客様と株式会社LinkMeMineとの間の完全な契約を構成し、すべての事前の契約、通知、説明に優先します。お問い合わせは support@linkmemine.com までご連絡ください。",
  "auto_install_multiple": "複数デバイスへの自動インストール",
  "single_agent_install": "単一エージェントのインストール",
  "license_exceeded_notice": "ライセンス上限を超えました",

  // MDM (デバイスポリシー・アプリ管理)
  "mdm_page": {
    "device_policy": "デバイスポリシー",
    "app_management": "アプリ管理",
    "config_name": "構成名",
    "config_name_search": "構成名で検索",
    "add_config": "構成を追加",
    "os": "OS",
    "all_os": "全OS",
    "description": "説明",
    "actions": "操作",
    "copy": "コピー",
    "cannot_delete": "削除不可",
    "no_config": "登録された構成がありません",
    "package_id": "パッケージID",
    "package_id_search": "パッケージIDで検索",
    "app_name": "アプリ名",
    "app_name_search": "アプリ名で検索",
    "add_app": "アプリを追加",
    "install_file": "インストールファイル",
    "format": "形式",
    "file_placeholder": "インストールファイルを選択",
    "file_browse": "参照",
    "allowed_ext": "{ext} ファイルのみアップロードできます",
    "invalid_ext": "{ext} ファイルのみアップロードできます",
    "apk_auto_extract": "APKからアプリ名・パッケージ名・バージョンを自動抽出します",
    "install_options": "インストールオプション",
    "silent_enable": "ユーザー操作なしでインストール",
    "silent_select_file_first": "インストールファイルを先に選択してください",
    "installer_detected_short": "{name} を検出",
    "installer_not_detected": "種類を認識できず、サイレントインストールを使用できません",
    "installer_msi": "MSI",
    "installer_nsis": "NSIS",
    "installer_inno": "Inno Setup",
    "installer_installshield": "InstallShield",
    "run_after_install": "インストール後に自動実行",
    "upload": "アップロード",
    "uploading": "アップロード中...",
    "file_required": "インストールファイルを選択してください",
    "app_name_required": "アプリ名を入力してください",
    "app_name_help": "ファイル名から自動入力されます — 必要に応じて修正してください",
    "version_required": "バージョンを入力してください",
    "app_uploaded": "アプリをアップロードしました",
    "config": "構成",
    "no_app": "登録されたアプリがありません",
    "edit_config": "構成の編集",
    "view_config": "構成の詳細",
    "os_immutable": "OSは作成後に変更できません",
    "location_track": "位置追跡",
    "location_track_use": "デバイスの位置追跡を使用",
    "info_update_interval": "デバイス情報の報告周期",
    "seconds": "秒",
    "update_schedule": "アプリ更新予約（Android専用）",
    "update_schedule_help": "入力した時刻は現地タイムゾーン基準で、UTCに変換して保存されます。営業時間を避けて設定してください。",
    "window_start": "開始時刻",
    "window_end": "終了時刻",
    "name_required": "構成名を入力してください",
    "interval_required": "報告周期は1秒以上にしてください",
    "schedule_time_required": "予約の開始/終了時刻を入力してください",
    "config_created": "構成を作成しました",
    "config_updated": "構成を更新しました",
    "config_copied": "構成をコピーしました",
    "config_deleted": "構成を削除しました",
    "copy_config": "構成のコピー",
    "confirm_copy": "構成「{name}」をコピーしますか？ポリシーとアプリ設定も複製されます。",
    "delete_config": "構成を削除",
    "confirm_delete": "構成「{name}」を削除しますか？",
    "install_policy_title": "「{app}」インストールポリシー",
    "install_policy_help": "このアプリを各構成にどう適用するかを設定します。",
    "install_policy": "インストールポリシー",
    "all_configs": "全構成",
    "companywide_badge": "全体適用",
    "state_install": "インストール",
    "state_none": "未設定",
    "state_uninstall": "削除",
    "install_policy_saved": "構成ごとのインストールポリシーを保存しました",
    "delete_app": "アプリを削除",
    "confirm_delete_app": "アプリ「{name}」を削除しますか？",
    "app_deleted": "アプリを削除しました",
    "tab_settings": "設定",
    "tab_applications": "アプリケーション",
    "profile_apps_help": "この構成に含めるアプリとインストールポリシーを設定します。",
    "profile_apps_saved": "構成のアプリインストールポリシーを保存しました",
    "save_profile_first": "構成を先に保存するとアプリを設定できます",
  },

}
